<ng-container [ngSwitch]="leaderStatus">
  <nz-row [nzGutter]="[8, 0]">
    <nz-col>
      <div *ngSwitchCase="BidLeaderStatus.LeaderAuctionEnd" class="green">
        <div>{{ 'LEADER_STATUS.AUCTION_END' | translate }}</div>
        {{ 'LEADER_STATUS.LEADER' | translate }}
      </div>
      <div *ngSwitchCase="BidLeaderStatus.NotLeaderAuctionEnd" class="red">
        <div class="green">{{ 'LEADER_STATUS.AUCTION_END' | translate }}</div>
        {{ 'LEADER_STATUS.NOT_LEADER' | translate }}
      </div>
      <div *ngSwitchCase="BidLeaderStatus.Negotiations" class="green">
        {{ 'LEADER_STATUS.NEGOTIATIONS' | translate }}
      </div>
      <div *ngSwitchCase="BidLeaderStatus.BestBid" class="blue">
        {{ 'LEADER_STATUS.LEADER_WAITING' | translate }}
      </div>
      <div *ngSwitchCase="BidLeaderStatus.LeaderRisky" class="green">
        {{ 'LEADER_STATUS.LEADER' | translate }}
        <div class="blue">{{ 'LEADER_STATUS.LEADER_RISK' | translate }}</div>
      </div>
      <div *ngSwitchCase="BidLeaderStatus.Leader" class="green">
        {{ 'LEADER_STATUS.LEADER' | translate }}
      </div>
      <div *ngSwitchCase="BidLeaderStatus.NotLeader" class="red">
        {{ 'LEADER_STATUS.NOT_LEADER' | translate }}
      </div>
    </nz-col>
    <nz-col>
      <span
        nz-icon
        nzType="info-circle"
        nzTheme="outline"
        nz-tooltip
        [nzTooltipTitle]="'LEADER_STATUS.LEADER_TOOLTIP' | translate"
      ></span>
    </nz-col>
  </nz-row>
</ng-container>
